<template>
  <div>
    <autoLogout />
    <loader :loader="loader" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text class="calendar">
          <v-row align="baseline" justify="center" class="">
            <branch-offices-list
              :classOfDiv="cols"
              style="padding-top: 22px"
              v-on:triggerChange="branchOfficeSelected"
              :model="idBranchOfficeSelected"
            />
           
            <v-col cols="12" md="3" xl="3" sm="12">
              <vc-date-picker
                color="green"
                v-model="range"
                is-range
                :max-date="new Date()"
                class="pb-0"
              >
                <template v-slot="{ inputEvents }">
                  <div class="d-flex justify-center align-center">
                    <v-text-field
                      v-on="inputEvents.start"
                      :value="rangeComputed"
                      label="Seleccione fecha"
                      :append-icon="
                        validData ? 'mdi-eraser' : 'mdi-calendar'
                      "
                      @click:append="clearCalendar"
                      :disabled-input="validData"
                    ></v-text-field>
                  </div>
                </template>
              </vc-date-picker>
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :items="listHistDisp"
            :headers="headers"
            :search="search"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
              'page-text': '{1} de {2}',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.prescriptionDate`]="{ item }">
              {{ $utilFront.formatDateTime(item.prescriptionDate) }}
            </template>
            <template v-slot:[`item.dispenseDate`]="{ item }">
              {{ $utilFront.formatDateTime(item.dispenseDate) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="getPrescriptionData(item)" icon>
                    <v-icon color="secondary" v-bind="attrs" v-on="on">
                      mdi-information-variant
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ver información de dispensación</span>
              </v-tooltip>
              <v-menu
                offset-y
                :nudge-width="200"
                :close-on-content-click="true"
              >
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Más opciones</span>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-list-item link @click="exportPDF(item)">
                    <v-list-item-icon>
                      <v-icon color="error" size="20px">
                        mdi-file-pdf-box
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Descargar receta</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-row align="baseline" justify="center" class="text-center py-4">
            <v-col>
              <v-btn
                outlined
                small
                color="error"
                @click="showModalReport(1, 1)"
                :disabled="sending"
                v-if="$utilFront.withPermission($prm.MODULE_PHARMACY_DETAILED)"
              >
                Listado detallado de dispensaciones
                <v-icon right> mdi-file-pdf-box </v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                outlined
                small
                color="success"
                @click="showModalReport(1, 2)"
                :disabled="sending"
                v-if="$utilFront.withPermission($prm.MODULE_PHARMACY_DETAILED)"
              >
                Listado detallado de dispensaciones
                <v-icon right> mdi-file-excel-box </v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                outlined
                small
                color="error"
                @click="showModalReport(2, 1)"
                :disabled="sending"
                v-if="$utilFront.withPermission($prm.MODULE_PHARMACY_CONDENSED)"
                >Dispensación consolidada por día
                <v-icon right> mdi-file-pdf-box </v-icon>
              </v-btn>
            </v-col>

            <!--<v-col>
              <v-btn
                outlined
                small
                color="light-blue darken-2"
                :disabled="sending"
                @click="downloadReport()"
                >Imprimir
                <v-icon right>mdi-printer</v-icon>
              </v-btn>
            </v-col>-->

            <v-col>
              <v-btn
                outlined
                small
                color="green darken-1"
                :disabled="sending"
                @click="downloadReportXLSX()"
                >Exportar excel
                <v-icon right>mdi-microsoft-excel</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>

        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="text-h6 text-center">
              Día a consultar
            </v-card-title>
            <v-card-text>Seleccione un día</v-card-text>
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-col>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Día"
                      rules="required"
                    >
                      <v-text-field
                        label="Día"
                        hint="Formato DD/MM/YYYY"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        :error-messages="errors"
                        :value="dateComputed"
                        v-on="on"
                        readonly
                      ></v-text-field>
                    </validation-provider>
                  </template>
                  <vc-date-picker
                    v-model="date"
                    min="1950-01-01"
                    locale="es"
                    :max-date="new Date()"
                  ></vc-date-picker>
                </v-menu>
              </v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeDialog()">
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="downloadReport()"
                  :disabled="invalid"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </validation-observer>
          </v-card>
        </v-dialog>
      </v-card>
      <encabezado :elementos="titleDetails" v-if="showAction(2)" />
      <v-card v-if="showAction(2)">
        <v-card-text>
          <v-container>
            <v-row justify="space-around" v-if="flagComponentInfo && objPrescription && objPrescription.idPatient">
                <v-col cols="12" md="12" sm="12">
                  <patient-information :model="objPrescription" />
                </v-col>
              </v-row>
            <v-form>
              <!-- <v-subheader>Datos del paciente</v-subheader>
              <v-row class="mb-2">
                <v-col>
                  <v-text-field
                    label="Nombre(s)"
                    v-model="objPrescription.fullNamePatient"
                    prepend-icon="mdi-account"
                    disabled
                  ></v-text-field>
                </v-col> -->
                <!-- <v-col>
                  <v-text-field
                    label="Primer apellido"
                    v-model="objPrescription.patient.person.firstLastname"
                    prepend-icon="mdi-card-account-details"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Segundo apellido"
                    v-model="objPrescription.patient.person.secondLastname"
                    prepend-icon="mdi-card-account-details-outline"
                    disabled
                  ></v-text-field>
                </v-col> -->
              <!-- </v-row> -->
              <v-row dense class="text-left mt-4">
                  <v-col cols="12" sm="12" md="12"><v-banner color="primary" class="mb-4" dark shaped single-line
                      align="left">
                      Información de receta
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row dense class="ml-2 mb-4">
                  <v-col  md="4" sm="12">
                    <strong>Id receta: </strong>
                    {{objPrescription.idPrescription }}</v-col>
                  <v-col  md="4" sm="12">
                    <strong>Fecha de solicitud: </strong>
                    {{ $utilFront.formatDateTime(objPrescription.prescriptionDate ) }}
                  </v-col>
                  <v-col md="4" sm="12">
                    <strong>Fecha de dispensación: </strong>
                    {{ $utilFront.formatDateTime(objPrescription.dispenseDate ) }}
                  </v-col>
                </v-row>

            </v-form>
  
            <v-row dense class="text-left mt-4">
                  <v-col cols="12" sm="12" md="12"><v-banner color="blue-grey lighten-5" class="mb-4 black--text" shaped single-line
                      align="left">
                      Productos recetados
                    </v-banner>
                  </v-col>
                </v-row>
            <v-row>
              <v-col>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Clave</th>
                        <th>Producto</th>
                        <th>Descripción</th>
                        <th class="text-center">Cantidad prescrita</th>
                        <th class="text-center">Cantidad dispensada</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(product, index) in productsPrescription"
                      :key="index"
                    >
                      <tr>
                        <td>{{ product.product_key }}</td>
                        <td>{{ product.name }}</td>
                        <td>{{ product.text }}</td>
                        <td class="text-center">{{ product.request }}</td>
                        <td>
                          <v-row align="center" justify="center">
                            <v-col
                              ><v-text-field
                                disabled
                                type="number"
                                :max="product.request"
                                v-model="product.dispensed"
                                :suffix="`/${product.request}`"
                              ></v-text-field
                            ></v-col>
                          </v-row>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="center">
            <v-col cols="10">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <v-btn plain color="error" @click="changeAction(1)">
                    <v-icon left>mdi-chevron-left</v-icon>
                    Volver
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import Datatable from "@/components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import moment from "moment";
import BtnAccion from "@/components/btnAccion.vue";
import {
  PrescriptionRequest,
  ReportPDFRequest,
  PharmacyPrescriptionRequest,
} from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import BranchOfficesList from "../../components/BranchOfficesList.vue";

import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
export default {
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
    ValidationProvider,
    ValidationObserver,
    extend,
    BranchOfficesList,
    PatientInformation,
  },
  name: "FarmaciaHistorial",
  data: () => ({
    action: 1,

    loader: false,
    encabezado: { icono: "mdi-pill", texto: "Historial de dispensaciones | Farmacia" },
    listHistDisp: [],
    icono: "mdi-information-variant",
    headers: [
      { text: "Id Receta", value: "idPrescription", align: "center" },
      { text: "Id Paciente", value: "idPatient", align: "center" },
      {
        text: "Nombre del paciente",
        value: "fullNamePatient",
        align: "center",
      },
      { text: "Nombre del doctor", value: "nameDoctor", align: "center" },
      {
        text: "Dispensador",
        value: "humanResourceExpedition",
        align: "center",
      },
      {
        text: "Fecha de solicitud",
        value: "prescriptionDate",
        align: "center",
      },
      {
        text: "Fecha de dispensación",
        value: "dispenseDate",
        align: "center",
      },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    search: "",
    range: "",
    btnPending: {
      route: "/farmacia/pendientes",
      icon: "mdi-pill",
      text: "Pendientes por dispensar",
      tooltip: "Surtir receta",
    },
    options: { page: 1, itemsPerPage: 10 },
    totalCount: 0,
    delayed: null,
    date: "",
    sending: false,
    dialog: false,
    dialog1: false,
    menu1: false,
    pharmacyHistoryDay: null,
    activePicker: null,
    date: null,
    menu2: false,
    typeReport: null,
    idBranchOfficeSelected: null,
    cols: "col-md-3 col-xl-3 col-sm-12",
    typeFile: 1,

    // ! DISPENSE DETAILS
    titleDetails: { icono: "mdi-pill", texto: "Detalles de dispensación" },
    objPrescription: {
      patient: {
        person: {},
      },
    },
    productsPrescription: [],
    dispensed: {},

    /***** */
    /**@MdePallares */
    flagComponentInfo: false,
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${moment(new Date(this.range.start)).format(
        "DD/MM/YYYY"
      )} al ${moment(new Date(this.range.end)).format("DD/MM/YYYY")}`;
    },
    dateComputed() {
      if (this.date === null || this.date === "" || this.date === undefined) {
        return "";
      }
      return `${moment(new Date(this.date)).format("DD/MM/YYYY")}`;
    },

    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },

    currentDate() {
      return moment(new Date()).format("YYYY-MM-DD HH:mm:ss a");
    },
  },
  watch: {
    options: function(newVal, oldVal) {
      // if (
      //   newVal.page != oldVal.page ||
      //   newVal.itemsPerPage != oldVal.itemsPerPage
      // ) {
      //   this.listAll();
      // }
    },
    search: function(newVal, oldVal) {
      // if (newVal == "") {
      //   this.listAll();
      // } else {
      //   if (this.delayed) {
      //     clearTimeout(this.delayed);
      //     this.delayed = null;
      //   } else {
      //     this.search = newVal;
      //     this.delayed = setTimeout(this.listAll(), 500);
      //   }
      // }
    },
  },
  created() {
    this.validBrowserTab();
    this.getMedicalPrescriptionsByBranch();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.date = null;
      this.$refs.observer.reset();
    },
    changeAction(action) {
      if (action === 1) {
        this.flagComponentInfo = false;
        this.action = action;
      } else if (action == 2) {
        this.loader = false;
        this.action = action;
      }
    },
    showAction(action) {
      return this.action == action;
    },

    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    saveNac(date) {
      this.$refs.menu1.save(date);
    },
    getMedicalPrescriptionsByBranch() {
      if (true) {
        this.loader = true;
        let params = {
          status: 2,
          idBranchOffice: this.$utilFront.nonEmpty(
            this.idBranchOfficeSelected,
            this.$utilFront.getIdBranchOffice()
          ),
        };

        if (this.$utilFront.nonEmpty(this.range)) {           
          params.start = this.$utilFront.startOfDay(this.range.start);           
          params.end = this.$utilFront.endOfDay(this.range.end);         
        }

        // params = Object.assign(params, this.range);

        // if (
        //   this.$utilFront.nonEmpty(params.start) &&
        //   this.$utilFront.nonEmpty(params.end)
        // ) {
        //   params.start = this.$utilFront.startOfDay(params.start);
        //   params.end = this.$utilFront.endOfDay(params.end);
        // }

        PrescriptionRequest.listAllPrescriptionByStatus(params)
          .then((res) => {
            let { data, code } = res.data;

            if (code == 200) {
              this.listHistDisp = data;
            } else {
              this.$utilFront.notifications(
                data || "Error al listar información.",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        try {
          this.loader = true;
          this.listHistDisp = [];
          this.totalCount = 0;
          let data = {
            page: this.options.page || 1,
            itemsPerPage: this.options.itemsPerPage || this.itemsPerPage || 2,
            search: this.search || "",
            start: this.range.start || null,
            end: this.range.end || null,
          };
          if (data.start != null && data.end != null) {
            data.start = moment(data.start).startOf("day");
            data.end = moment(data.end).endOf("day");
          }
          data = {
            status: 2,
            idBranchOffice:
              this.idBranchOfficeSelected != null
                ? this.idBranchOfficeSelected
                : this.$utilFront.getIdBranchOffice(),
            filter: data,
          };

          PrescriptionRequest.listAllPrescriptionByStatusPaged(data)
            .then((res) => {
              let { data, message, response, totalCount } = res.data;
              if (response) {
                this.totalCount = totalCount;
                this.listHistDisp = data.map((medpre) => {
                  let user = `${medpre.diagnostic.medicalPractice.appointment.clinicalEvent.patient.person.name} ${medpre.diagnostic.medicalPractice.appointment.clinicalEvent.patient.person.firstLastname} ${medpre.diagnostic.medicalPractice.appointment.clinicalEvent.patient.person.secondLastname}`;
                  user = user.replace("null", "").replace("  ", " ");

                  let doctor = medpre.diagnostic.humanResource.person.fullName;

                  return {
                    idPrescription: medpre.idPrescription,
                    user: user,
                    doctorName: doctor,
                    expeditionDate: moment(
                      new Date(medpre.expeditionDate)
                    ).format("DD/MM/YYYY HH:mm"),
                    dispensingDate: moment(
                      new Date(medpre.dispensingDate)
                    ).format("DD/MM/YYYY HH:mm"),
                    patientName:
                      medpre.diagnostic.medicalPractice.appointment
                        .clinicalEvent.patient.person.name,
                    patientLastName:
                      medpre.diagnostic.medicalPractice.appointment
                        .clinicalEvent.patient.person.firstLastname,
                    patientSecondLastname:
                      medpre.diagnostic.medicalPractice.appointment
                        .clinicalEvent.patient.person.secondLastname,
                    prescriptionDate: medpre.expeditionDate,
                  };
                });
              }
            })
            .catch((err) => {
              //console.log(err);
              this.$utilFront.notifications(
                "Ha ocurrido un error interno",
                "ERROR"
              );
            })
            .finally(() => {
              this.loader = false;
            });
        } catch (error) {
          //console.log(error);
          this.$utilFront.notifications(
            "Ha ocurrido un error interno",
            "ERROR"
          );
        }
      }
    },
    clearCalendar() {
      this.range = "";
      this.listAll();
    },
    getDispensedDescription(item) {
      this.$router.push({
        name: "FarmaciaDetalle",
        params: { dataPrescription: item },
      });
    },
    exportPDF(item) {
      let url = new URL(location.origin);
      let data = {
        idPrescription: item.idPrescription,
        url: url,
        fileName: "Receta",
      };
      this.loader = true;
      ReportPDFRequest.downloadPrescription(data, this);
    },
    listAll() {
      this.getMedicalPrescriptionsByBranch();
    },
    downloadReportXLSX() {
      this.sending = true;
      this.loader = true;

      let data = {
        page: this.options.page || 1,
        itemsPerPage: -1,
        search: this.search || ""
      };

      if (this.$utilFront.nonEmpty(this.range)) {           
        data.start = this.$utilFront.startOfDay(this.range.start);           
        data.end = this.$utilFront.endOfDay(this.range.end);         
      }
      
      data = {
        status: 2,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        filter: data,
      };

      ReportPDFRequest.downloadReportPrescriptionsXLSX(data)
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );

          /* Simulo el click */
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Reporte de dispensaciones.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.loader = false;
          this.sending = false;
        });
    },

    showModalReport(value, typeFile) {
      this.typeReport = value;
      this.dialog = true;
      this.typeFile = typeFile;
    },

    downloadReport() {
      if (this.typeReport == 1) {
        this.downloadPharmacyDetailed();
      } else if (this.typeReport == 2) {
        this.downloadPharmacyCondensed();
      }
    },

    downloadPharmacyDetailed() {
      this.sending = true;
      this.loader = true;
      let data = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        day: this.date,
        fileName: "Historial",
        typeFile: this.typeFile,
      };
      if (data.day != null) {
        data.day = moment(data.day).startOf("day");
      }

      ReportPDFRequest.downloadPharmacyDetailed(data)
        .then((response) => {
          switch (this.typeFile) {
            case 1: //PDF
              //this.$utilFront.openPDF(res.data);
              if (
                response.status == 200 &&
                response.data.type != "application/json"
              ) {
                this.$utilFront.openPDF(response.data);
              } else {
                this.$utilFront.displayErrorPdf(response.data);
              }
              break;
            case 2: //XLSX
              this.$utilFront.downloadXLSX(
                response.data,
                "Remisión de salida - Detallado.xlsx"
              );
              break;
          }
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
          this.closeDialog();
        });
    },
    downloadPharmacyCondensed() {
      this.sending = true;
      this.loader = true;

      let data = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        day: this.date,
        fileName: "Historial",
      };

      if (data.day != null) {
        data.day = moment(data.day).startOf("day");
      }

      ReportPDFRequest.downloadPharmacyCondensed(data)
        .then((response) => {
          if (
            response.status == 200 &&
            response.data.type != "application/json"
          ) {
            this.$utilFront.openPDF(response.data);
          } else {
            this.$utilFront.displayErrorPdf(response.data);
          }
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
          this.closeDialog();
        });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.getMedicalPrescriptionsByBranch();
    },

    // ! DISPENSE details
    getPrescriptionData(item) {
      this.changeAction(2);
      this.objPrescription = item;
      this.flagComponentInfo = true;
      this.getProductByPrescription(this.objPrescription.idPrescription);
      this.objPrescription.prescriptionDate = this.objPrescription.prescriptionDate;
      this.objPrescription.dispenseDate = this.objPrescription.dispenseDate;
    },
    getProductByPrescription(idPrescription) {
      PharmacyPrescriptionRequest.listPharmacyPrescriptionByPrescription({
        idPrescription: idPrescription,
      }).then((res) => {
        this.loader = true;
        if (res.data.code === 200 && res.data.status === "OK") {
          this.productsPrescription = res.data.data.map((product) => {
            return {
              idProduct: product.products.idProduct,
              product_key: product.products.product_key,
              name: product.products.name,
              text: product.products.text,
              request: product.request,
              dispensed: product.dispensed,
            };
          });
          this.loader = false;
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
  },
};
</script>
